import type { GridProps } from "@mui/material";
import { Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import React from "react";

interface Props {
  items: TileItemProps[];
}

interface TileItemProps {
  title: string;
  content: string | React.ReactNode;
  gridProps?: GridProps;
}

const TileItem = ({ title, content, gridProps }: TileItemProps) => (
  <Grid size="grow" {...gridProps}>
    <Stack spacing={0.5} sx={{ alignItems: "flex-start" }}>
      <Typography variant="caption" color="textSecondary">
        {title}
      </Typography>
      {typeof content === "string" ? <Typography variant="subtitle2">{content}</Typography> : content}
    </Stack>
  </Grid>
);

const DividerItem = () => (
  <Grid>
    <Divider orientation="vertical" />
  </Grid>
);

const HorizonatalTilesInfoBar = ({ items }: Props) => {
  return (
    <Paper variant="outlined" sx={{ py: 2, pl: 2 }}>
      <Grid container spacing={2.5}>
        {items.map((item, index) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <React.Fragment key={index}>
            <TileItem {...item} />
            {index < items.length - 1 && <DividerItem />}
          </React.Fragment>
        ))}
      </Grid>
    </Paper>
  );
};

export default HorizonatalTilesInfoBar;
